// extracted by mini-css-extract-plugin
export default {"menu":"styles_menu__7BCk7","popup":"styles_popup__9pkdM","item":"styles_item__GuPPW","subNav":"styles_subNav__IgVPv"};